import React, { Component } from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import logo from './img/ll.png'
import { Container } from '@mui/material';


function Appbar() {

  let currentLocation = window.location.pathname


  return (
    <div>
    <Box sx={{width:'100%',mb:5 , display:currentLocation=='/'?'block':'block'}}>
    <AppBar elevation={2} position="fixed" sx={{height:45,backgroundColor:'#fff',boxShadow:'#a0a0a0'}}>
    
    <Toolbar  variant="dense" sx={{width:"100%",display:'flex',justifyContent:'space-between'}}>
   <img src={logo} style={{height:40,objectFit:'contain'}}/>
  
   <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            sx={{mr:{xs:3,sm:4}}}
            //onClick={handleMenu}
            color="inherit"
          >
            <AccountCircle sx={{color:'#1b7bce'}} />
          </IconButton>

    </Toolbar>

</AppBar>
</Box>

</div>
  )
}

export default Appbar